import { useEffect } from 'react';

export const useInitialFocus = (
    ref: React.RefObject<HTMLElement | null>,
    triggerFocus: boolean,
) => {
    useEffect(() => {
        if (triggerFocus && ref.current) {
            ref.current.focus();
        }
    }, [ref, triggerFocus]);

    return ref;
};
